module.exports = __webpack_public_path__ + "img/html-evolution-2.febaee83.webp";